import {SpaceProto} from "../../../../../model2/space/space-proto"
import {NavigationSectionType} from "../../../../../model2/navigation/@const"
import ProjectSession from "../../../../../model2/project/project-session"
import {ItemDisplay} from "../../../../../model2/item/@type"
import {SortDirection} from "../../../../../data-structures/sort"

// Same space list "Move to"'s project tree renders (`ModalMoveTo_ProjectsTree`):
// enabled spaces, alphabetical, with an empty Projects space dropped entirely.
// Shared by the tree renderer and the keyboard-cursor flattening so the two
// can never disagree on space order.
export function entitySelectorProjectSpaces(): SpaceProto[] {
    const projectsSpaceHasVisibleRootProjects = _.some(gd.spaces.projects.rootProjects, (project: ProjectSession) => {
        return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(project.treeDisplay)
    })

    return _(gd.spaces.spacesWithProjects)
        .filter((space: SpaceProto) => {
            return space.enabled
                && (space.id !== NavigationSectionType.PROJECTS || projectsSpaceHasVisibleRootProjects)
        })
        .orderBy([(space: SpaceProto) => space.title], [SortDirection.ASC])
        .value()
}
